export const Size = "VEC_BGR_090"; // Size code
export const GuidewayDesign = "VEC_SAF_090"; // Guideway design

export const Accuracy = "VEC_GEN_090"; // Accuracy class

export const ClosingPlugs = "VEC_SKA_090"; // Closing plugs

export const GuidewayLength = "VEC_KWL_090";
export const GuidewayLengthMin = "VEC_LMIN_090";
export const GuidewayLengthMax = "VEC_LMAX_090";

export const AL = "VEC_AAL_090";
export const ALMin = "VEC_AL_MIN_090";
export const ALMax = "VEC_AL_MAX_090";
export const AR = "VEC_AAR_090";
export const ARMin = "VEC_AR_MIN_090";
export const ARMax = "VEC_AR_MAX_090";

// It's hard max length for aL and aR
export const FixedHoleDistance = "VEC_JL_090";

export const PartSizing = "FAKE_PART_SIZING"; // Possible values: No parts, automatic split, manual split
export const PartAmount = "FAKE_PART_AMOUNT";

export const DesignType_Series = "VB_MKB_090";
export const DesignType_SizeCode = "VB_BGR_090";
export const DesignType_Version = "VB_VER_090";
export const DesignType_GuidewayDesign = "VB_SAF_090";
